import type { ReactNode } from "react"
import IconAtm from "@onestore/hel/dist/components/atoms/IconAtm"
import FlexContainerOrg from "@onestore/hel/dist/components/organisms/FlexContainerOrg"
import FlexItemOrg from "@onestore/hel/dist/components/organisms/FlexItemOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import type { UdsColor } from "@gatsby-plugin-generic-page/helpers/helTypographyToUds"
import { Text } from "@ionos-web-design-system/react"
import Tick from "@onestore-icons/tick.svg"
import styled from "styled-components"

const StyledLi = styled(PushOrg).attrs({ forwardedAs: "li" })``

export interface ListItemProps {
  children: ReactNode
  color?: UdsColor
}
function ListItem({ children, color }: ListItemProps) {
  return (
    <StyledLi bottomSpace={1.5}>
      <FlexContainerOrg alignItems="center">
        <FlexItemOrg flexShrink={0}>
          <IconAtm icon={Tick} sizeSpace={2} />
        </FlexItemOrg>

        <PushOrg leftSpace={1.5}>
          <Text variant="body" color={color}>
            {children}
          </Text>
        </PushOrg>
      </FlexContainerOrg>
    </StyledLi>
  )
}

export default ListItem
